(function () {
  var UNAUTHORIZED_ERROR = 401;
  $.ajaxSetup({
    error: function error(xhr) {
      switch (xhr.status) {
        case UNAUTHORIZED_ERROR:
          location.href = '/';
          break;

        default:
          break;
      }
    }
  });
})();